export const UPDATE_TUTOR_GROUP_REQUEST = 'tutorSessionUpdateReducer/UPDATE_TUTOR_GROUP';
export const UPDATE_TUTOR_GROUP_SUCCESS = 'tutorSessionUpdateReducer/UPDATE_TUTOR_GROUP_SUCCESS';
export const UPDATE_TUTOR_GROUP_FAILED = 'tutorSessionUpdateReducer/UPDATE_TUTOR_GROUP_FAILED';